import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StaffTodoListDatastore } from '../datasources/staff_todo_list_datastore';

export class StaffTodoService {
  constructor(private loadStaffTodoCommand: ICommand, private staffTodoListDatastore: StaffTodoListDatastore) {}

  async loadStaffTodos(dateRange: any) {
    if (!_4.isEmpty(this.staffTodoListDatastore.read())) {
      return this.staffTodoListDatastore.read();
    }
    this.loadStaffTodoCommand(dateRange)
      .then(() => {
        return this.staffTodoListDatastore.read();
      })
      .catch(() => {
        console.warn('Unable to get staff to-dos');
        return {};
      });
    return {};
  }
}

angular.module('data-ng-staff-todos').service('ngStaffTodoService', StaffTodoService);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/services/staff_todo_service.ts